import APIClient from '@/shared/http/clients/api'

const resourceName = 'businesstype'
const APIRegCommon = process.env.APIBaseURLRegulationCommon

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetAllByInsuranceID = (insuranceID, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}/insurance/${insuranceID}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APIRegCommon}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIRegCommon}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIRegCommon}/${resourceName}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIRegCommon}/${resourceName}/${id}`, config)

const BusinessTypeRepository = {
  GetAll,
  GetAllPaging,
  GetAllByInsuranceID,
  GetById,
  Create,
  Update,
  Delete
}

export default BusinessTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configuration/businesstype.js